import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "1052",
  height: "1052",
  viewBox: "0 0 1052 1052",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "path",
    d: "M1051 1051H1V1H1051V1051Z",
    stroke: "transparent",
    "stroke-width": "2"
  })
], -1)
const _hoisted_3 = ["id", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.players, (item) => {
      return (_openBlock(), _createElementBlock("img", {
        key: item.id,
        id: item.image,
        class: "pieces z-20",
        style: {"width":"50px"},
        src: item.link,
        alt: "",
        srcset: ""
      }, null, 8, _hoisted_3))
    }), 128))
  ]))
}